import { Component } from '@angular/core';

import { Register, ToolService } from '../../shared';


@Register({
  name: 'contextManager',
  title: 'igo.contexts',
  icon: 'bookmark'
})
@Component({
  selector: 'igo-context-manager-tool',
  template: require('./context-manager-tool.component.html'),
  styles: [require('./context-manager-tool.component.styl')]
})
export class ContextManagerToolComponent {

  constructor(private toolService: ToolService) {}

  editContext() {
    const tool = this.toolService.getTool('contextEditor');
    if (tool) {
      this.toolService.selectTool(tool);
    }
  }

  manageTools() {
    const tool = this.toolService.getTool('toolsContextManager');
    if (tool) {
      this.toolService.selectTool(tool);
    }
  }

  managePermissions() {
    const tool = this.toolService.getTool('permissionsContextManager');
    if (tool) {
      this.toolService.selectTool(tool);
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/context-manager-tool/context-manager-tool.component.ts